import React from 'react'
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper'
import style from "../TermAndPolicy/TermAndPolicy.module.css"
import Header from '../../components/DashBoard/Header'
const ContactUs = () => {
  return (
    <>
    <Header/>
    <SlideUpWrapper>
        <div className={style.TermAndPolicy}>

                  <h1>Contact Us</h1>


                  <div className={style.ContactUs}>
                    <h1>Get in Touch with Our Team</h1>
                    <p className={style.paragraph}>We're here to answer your questions, and help you find the best solutions to your software needs.</p>
                    <p className={style.paragraph}>Reach out to us, and let's start building something great together.</p>
                    <div style={{width:"100%", display:"flex", justifyContent:"space-between"}}>
                  <div className={style.ContactUsData}>
                    <div style={{width:"100%", display:"flex", flexDirection:"column", alignItems:"center"}}>
                        <h1>Let's Talk</h1>
                        {/* <div className={style.userInputBox}>
                                        <label htmlFor="firstname">Name</label>
                                        <input type="text" id="firstname" name="firstname" value="ABC" placeholder="e.g.Bonnie Green" />
                                      {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
                        </div>
                        <div className={style.userInputBox}>
                                        <label htmlFor="firstname">Email</label>
                                        <input type="text" id="firstname" name="firstname" value="ABC" placeholder="e.g.Bonnie Green" />
                                      {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
                        </div>
                        <div className={style.userInputBox}>
                                        <label htmlFor="firstname">Company Name</label>
                                        <input type="text" id="firstname" name="firstname" value="ABC" placeholder="e.g.Bonnie Green" />
                                      {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
                        </div>
                        <div className={style.userInputBox}>
                                        <label htmlFor="firstname">Subject</label>
                                        <input type="text" id="firstname" name="firstname" value="ABC" placeholder="e.g.Bonnie Green" />
                                      {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
                        </div>
                        <div className={style.userInputBox}>
                                        <label htmlFor="firstname">Message</label>
                                        <textarea type="text" id="firstname" name="firstname" value="ABC" placeholder="e.g.Bonnie Green" />
                                      {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
                        </div> */}
                        <div className={style.paragraph}>
                        If you would like to outsource the employment verification of your ex-employees or would like to come onboard as our registered Verifying partner
                        </div>
                        <div>
<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150"
     viewBox="0 0 24 24" fill="none" stroke="currentColor"
     stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
     aria-label="Contact support">
  <path d="M4 12a8 8 0 0116 0" />
  <rect x="3" y="11" width="3" height="5" rx="1" />
  <rect x="18" y="11" width="3" height="5" rx="1" />
  <circle cx="12" cy="10" r="2.5" />
  <path d="M16 16v.5a3.5 3.5 0 01-3.5 3.5H9.5" />
</svg>

</div>
                    </div>
                    </div>
                    <div>
                        <h1>Prefer to Direct Approch?</h1>
                        <div style={{margin:"1rem"}}>
                        <p className={style.paragraph}>Support</p>
                        <div style={{display:"flex", gap:"10px"}}>
                            <img src='/mail.svg' alt='mail.svg' style={{marginBottom:"1rem"}}/>
                            <p className={style.paragraph}>authnumber-support@authbridge.com</p>
                        </div>
                        <div style={{display:"flex", gap:"10px"}}>
                            <img src='/phonecall.svg' alt='phonecall.svg' style={{width:"22px", height:"22px", marginBottom:"1rem"}}/>
                            <p className={style.paragraph}>+91 9310658619</p>
                        </div>
                        </div>
                        <div style={{margin:"1rem"}}>
                        <p className={style.paragraph}>Corporate Headquaters</p>
                        <p className={style.paragraph}>Authbridge Research Services Pvt. Ltd.</p>
                        <p className={style.paragraph}>8th Floor, Smartworks Golf View Towers,</p>
                        <p className={style.paragraph}>Tower-B, Sector 42,</p>
                        <p className={style.paragraph}>Gurgaon-122009</p>
                        <p className={style.paragraph}>Haryana, India</p>

                        </div>
                        
                        
                    </div>
                  </div>
                  </div>

                  </div>
    </SlideUpWrapper>
    </>
  )
}

export default ContactUs